import { StarsDropDown } from '@ps/web-shared-components';
import { createForm } from '@ps/web-shared-ui';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { dialingCodeSelectOptions, getInitialOptions } from '@swf/core/utils/phoneVerification';

import { TXTCLI_Code } from './PhoneVerification.messages.json';
import styles from './PhoneVerification.scss';
import ValidateCode from './ValidateCode/ValidateCode';
import VerifyNumber from './VerifyNumber/VerifyNumber';

interface PhoneVerificationComponent extends React.FC<Props> {
  VerifyNumber: typeof VerifyNumber;
  ValidateCode: typeof ValidateCode;
}

type SVGProps = React.SVGAttributes<SVGElement>;

interface Props {
  showVerifyLater?: boolean;
  fieldName?: string;
  icon?: React.ReactElement<SVGProps, React.FunctionComponent<SVGProps>>;
}

interface FormValues {
  dialingCode: string;
  phoneNumber: string;
  validationCode: string;
}

enum VerifyStep {
  VerifyNumber,
  ValidateCode
}

const Form = createForm<FormValues>();

const PhoneVerification: PhoneVerificationComponent = ({
  showVerifyLater,
  fieldName = 'phoneNumber',
  icon
}) => {
  const phone = useSelector(select.account.getPhone) as string;
  const country = useSelector(select.account.getCountry) as string;
  const initialValues = getInitialOptions(phone, country);
  const [verifyStep, setVerifyStep] = useState(VerifyStep.VerifyNumber);

  const verifyNumber = () => setVerifyStep(VerifyStep.ValidateCode);

  const goBack = () => setVerifyStep(VerifyStep.VerifyNumber);

  return (
    <Form
      onSubmit={() => undefined}
      initialValues={initialValues}
      render={() => (
        <>
          {verifyStep === VerifyStep.VerifyNumber && (
            <VerifyNumber verifyNumber={verifyNumber} fieldName={fieldName} icon={icon}>
              <div>
                <StarsDropDown
                  id="dialingCode"
                  name="dialingCode"
                  label={TXTCLI_Code}
                  className={styles.dropdown}
                  options={dialingCodeSelectOptions}
                />
              </div>
            </VerifyNumber>
          )}
          {verifyStep === VerifyStep.ValidateCode && (
            <ValidateCode goBack={goBack} showVerifyLater={showVerifyLater} />
          )}
        </>
      )}
    />
  );
};

PhoneVerification.VerifyNumber = VerifyNumber;
PhoneVerification.ValidateCode = ValidateCode;

export default PhoneVerification;
